require('./RAEvolutionChartTooltip.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { get } = require('lodash');

// @utilities
const {
    getFormattedString,
    formatAmount,
} = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');

// @constants
const { EURO_SYMBOL } = require('constants/index');
const { DATE_FORMAT } = require('../../raConstants/index');

class RAEvolutionChartTooltip extends React.Component {
    formatAmount() {
        const { payload, isValuation } = this.props;
        const value = get(payload, '[0].value', 0);

        if (isValuation) {
            const str = getFormattedString({
                amount: value,
                currency: EURO_SYMBOL,
            });
            return str;
        } else {
            return `${formatAmount(value, undefined, 2)}%`;
        }
    }

    render() {
        const { active, label } = this.props;
        const amount = this.formatAmount();
        const formattedDate = DateHelper.buildFormattedDate(label, DATE_FORMAT);
        if (active) {
            return (
                <div className="ra-evolution-chart-tooltip">
                    <span className="ra-evolution-chart-tooltip__title">
                        {formattedDate}
                    </span>
                    <span className="ra-evolution-chart-tooltip__subtitle">
                        {amount}
                    </span>
                </div>
            );
        } else {
            return null;
        }
    }
}

RAEvolutionChartTooltip.propTypes = {
    active: PropTypes.bool,
    isValuation: PropTypes.bool,
    label: PropTypes.string,
    payload: PropTypes.array,
    selectedOption: PropTypes.string,
};

module.exports = RAEvolutionChartTooltip;
